<template>
  <div class="contact">
    <div class="contact-inner">
      <div>Contact</div>
      <div></div>
      <div>Comments and suggestions are welcomed</div>
      <div>
        If you meet any troubles or find any bugs when you visit PLncDB,please email to
        <b>jinjingjing1218@126.com, peijiancao@163.com</b> or you can contact us by:
      </div>
      <div>Tel: +86-0371-67672080</div>
      <div>
        Address: No.2 Fengyang Street, High-Tech Zone, Zhengzhou, P. R., 450001
      </div>
      <!-- <div>
        <baidu-map></baidu-map>
      </div> -->
    </div>
  </div>
</template>
<script>
import BaiduMap from "../baiduMap/Map";

export default {
  name: "Map",
  data() {
    return {
      // // 经度
      // longitude: 113.573044,
      // // 纬度
      // latitude: 34.821643,
      // description: "天安门"
    };
  },
  components: {
    BaiduMap
  }
};
</script>

<style scoped>
.contact {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.contact .contact-inner {
  width: 1200px;
  height: auto;
  padding: 0px 20px;
  margin: 0 auto;
  padding-bottom: 15px;
  background: rgba(255, 255, 255, 1);
}
.contact .contact-inner div:first-child {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
}
.contact .contact-inner div:nth-child(2) {
  width: 100%;
  height: 1px;
  background: rgba(229, 233, 235, 1);
}
.contact .contact-inner div:nth-child(3) {
  height: 25px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin-top: 43px;
}
.contact .contact-inner div:nth-child(4) {
  height: 16px;
  font-size: 15px;
  font-family: PingFang SC;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
  margin-top: 18px;
}
.contact .contact-inner div:nth-child(5) {
  height: 28px;
  font-size: 15px;
  font-family: PingFang SC;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
  margin-top: 26px;
}
.contact .contact-inner div:nth-child(6) {
  height: 15px;
  font-size: 15px;
  font-family: PingFang SC;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
  margin-top: 10px;
}
.contact .contact-inner div:last-child {
  width: 100%;
  height: 40px;
  margin-top: 30px;
  font-size: 15px;
  font-weight: normal;
  font-family: PingFang SC;
}
b {
  color: rgba(139, 182, 68, 1);
  font-size: 18px;
}
</style>
